import { useEffect, useMemo, useState } from "react";
import * as api from "../api/service/report-variables";
import { normalizeError } from "../operationFeedback/normalizeError";
import { createReportMutationQueue } from "./reportMutationQueue";

export function useReportVariableMutations(reportId) {
  const [problem, setProblem] = useState(null);
  const [version, setVersion] = useState(null);
  const [pending, setPending] = useState(0);
  const queue = useMemo(() => createReportMutationQueue({
    onSaved: (_saved, next) => setVersion(next),
    onError: error => setProblem(normalizeError(error)),
    onPendingChange: setPending,
  }), [reportId]);
  useEffect(() => {
    queue.start();
    setProblem(null);
    setVersion(null);
    return () => queue.stop();
  }, [queue]);
  const mutations = useMemo(() => Object.fromEntries(Object.entries(api)
    .filter(([name]) => /^(create|update|delete)/.test(name))
    .map(([name, fn]) => [name, (...args) => queue.run(editVersion => fn(...args, { editVersion }))])), [queue]);
  return { mutations, problem, version, pending, stop: queue.stop, fail: queue.fail,
    refreshToken: queue.refreshToken,
    replaceCleanSnapshot: (next, token) => { queue.replaceCleanSnapshot(next, token); setVersion(next); },
    adoptSnapshot: next => { queue.adoptSnapshot(next); setVersion(next); },
  };
}
